module.exports = __webpack_public_path__ + "img/进行中.af5e7944.png";